/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Pdd } from "./Pdd";
import * as t from "io-ts";

// required attributes
const PddsR = t.interface({
  pdds: t.readonlyArray(Pdd, "array of Pdd")
});

// optional attributes
const PddsO = t.partial({});

export const Pdds = t.intersection([PddsR, PddsO], "Pdds");

export type Pdds = t.TypeOf<typeof Pdds>;
